import { Component } from '@angular/core';

/**
 * Legend shown at the top of a record explaining the meaning of the field
 * indicators used consistently across the QCR app:
 *  - red asterisk (*)  => the field is required
 *  - amber triangle    => the field is needed for approval
 */
@Component({
  selector: 'app-form-legend',
  templateUrl: './form-legend.component.html',
  styleUrls: ['./form-legend.component.scss']
})
export class FormLegendComponent {}
